const EventNames = {
  HOME_TAB_OPENED: 'Home_Tab_Opened',
  PROMOTIONAL_BANNER_CLICKED: 'Promotional_Banner_Clicked',
  PROMOTIONAL_PAGE_VIEWED: 'Promotional_Page_Viewed',
  PROMOTIONAL_EVENT_REGISTER: 'Promotional_Event_Register',
  PROMOTIONAL_EVENT_STARTED: 'Promotional_Event_Started',
  FREE_VIDEO_CLICKED: 'Free_Video_Clicked',
  FREE_QUIZ_STARTED: 'Free_Quiz_Started',
  FREE_QUIZ_LANGUAGE_SWITCHED: 'Free_Quiz_Language_Switched',
  FREE_QUIZ_SUBMITTED: 'Free_Quiz_Submitted',
  FREE_SUBJECTIVE_QUESTION_STARTED: 'Free_Subjective_Question_Started',
  QUICK_LINK_CLICKED: 'Quick_Link_Clicked',
  COURSE_CARD_CLICKED: 'Course_Card_Clicked',
  COURSE_DETAILS_VIEWED: 'Course_Details_Viewed',
  COURSE_LIST_VIEWED: 'Course_List_Viewed',
  BROCHURE_DOWNLOADED: 'Brochure_Downloaded',
  BATCH_SELECTED: 'Batch_Selected',
  ENROLL_NOW_CLICKED: 'Enroll_Now_Clicked',
  COMBO_SELECTED: 'Combo_Selected',
  COMBO_ENROLL_NOW_CLICKED: 'Combo_Enroll_Now_Clicked',
  REQUEST_CALLBACK_CLICKED: 'Request_Callback_Clicked',
  FILTER_APPLIED: 'Filter_Applied',
  COURSES_SEARCH_INITIATED: 'Courses_Search_Initiated',
  PODCAST_STARTED: 'Podcast_Started',
  LIVE_CLASS_STARTED: 'Live_Class_Started',
  MOCK_TEST_STARTED: 'MockTest_Started',
  MOCK_TEST_INITIATED: 'MockTest_Initiated',
  TESTSERIES_SEARCH_INITIATED: 'TestSeries_Search_Initiated',
  TESTSERIES_CARD_CLICKED: 'TestSeries_Card_Clicked',
  TESTSERIES_DETAILS_VIEWED: 'TestSeries_Details_Viewed',
  TESTSERIES_LIST_VIEWED: 'TestSeries_List_Viewed',
  MOCK_TEST_REQUEST_CALLBACK_CLICKED: 'MockTest_Request_Callback_Clicked',
  MOCK_TEST_SUBMITTED: 'MockTest_Submitted',
  MOCK_TEST_LANGUAGE_SWITCHED: 'MockTest_Language_Switched',
  MOCK_TEST_SOLUTIONS_VIEWED: 'MockTest_Solutions_Viewed',
  MOCK_TEST_SOLUTIONS_DOWNLOADED: 'MockTest_Solutions_Downloaded',
  MOCK_TEST_LEADERBOARD_VIEWED: 'MockTest_Leaderboard_Viewed',
  TESTSERIES_SCHEDULE_DOWNLOADED: 'TestSeries_Schedule_Downloaded',
  MOCK_TEST_BROCHURE_DOWNLOADED: 'MockTest_Brochure_Downloaded',
  ERROR_BOUNDARY_FALLBACK: 'error_boundary_fallback',

  COUNSELLING_SESSION_BOOK_NOW_CLICKED: 'Counselling_Session_Book_Now_Clicked',
  COUNSELLING_SESSION_SLOT_BOOKED: 'Counselling_Session_Slot_Booked',
  STUDY_NOTES_OPENED: 'Study_Notes_Opened',
  STUDY_NOTES_LIST_OPENED: 'Study_Notes_List_Opened',
  FREE_QUIZ_LIST_OPENED: 'Free_Quiz_List_Opened',
  CALL_BUTTON_CLICKED: 'Call_Button_Clicked',
  DEMO_CLASS_STARTED: 'Demo_Class_Started',
  QCAB_UPLOADED: 'QCAB_Uploaded',
  QCAB_DELETED: 'QCAB_Deleted',
  QCAB_REUPLOADED: 'QCAB_Reuploaded',
  QCAB_DOWNLOADED: 'QCAB_Downloaded',
  HOW_TO_TAKE_TEST_CLICKED: 'How_To_Take_Test_Clicked',
  FREE_SUBJECTIVE_OCR_REJECTED: 'Free_Subjective_OCR_Rejected',
  FREE_SUBJECTIVE_QUESTION_SUBMITTED: 'Free_Subjective_Question_Submitted',
  FLEXI_COURSE_SELECTED: 'Flexi_Course_Selected',
  RAISE_A_DOUBT_CLICKED: 'Raise_A_Doubt_Clicked',
  DOUBT_SUBMITTED: 'Doubt_Submitted',
  EXTEND_NOW_CLICKED: 'Extend_Now_Clicked',
  // FREE_VIDEO_WATCHED_5MINS: 'Free_Video_Watched_5mins',
};

export default EventNames;
